export default {"src":"/_next/static/media/how-it-works-divider.774c0e90.svg","height":370,"width":962};